import { AuthGuard, CrudOp, roleAssignmentOverviewAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const RoleManagementView: FC = () => (
  <AuthGuard authScope={roleAssignmentOverviewAuthScope} crudOp={CrudOp.READ}>
    <Suspense><LazyRoleManagementView/></Suspense>
  </AuthGuard>
);

const LazyRoleManagementView = lazy(importView(
  () => import("../components/RoleManagementView"),
  (it) => it.RoleManagementView,
));
